/** State of a "copy this link" button: nothing clicked yet, copied, or the write was refused. */
export type CopyStatus = "idle" | "copied" | "failed";

/**
 * Copy `text` to the clipboard, resolving to whether it actually landed there.
 *
 * `navigator.clipboard.writeText` rejects on a denied permission, a blocking
 * extension, or a document that lost focus mid-write, and the whole API is
 * absent outside a secure context. Callers that flip a "Kopieret!" label
 * without checking end up claiming a success that never happened (and leaking
 * an unhandled rejection), so this narrows all of that to a single boolean.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
